import { InsureFundClient } from "../../../../Wrap/Api/Instruments/InsureFund";
import { InsuredFundBulkTradingClient } from "../../../../Wrap/Api/Instruments/InsuredFundBulkTrading";
import { InsuredFundTradingAccountClient } from "../../../../Wrap/Api/Instruments/InsuredFundTradingAccount";
import { BulkTradeMode } from "../../../../Wrap/Models/Models/Instruments/BulkTradeMode";
import { InsuredFundBulkTradeCommand } from "../../../../Wrap/Models/Models/Instruments/InsuredFundBulkTradeCommand";

export class InsuredFundAction {
    public static getInsureFundDetails(instrumentCode: string, enableNpr: boolean, callback: (data) => void): void {
        const client = new InsureFundClient();
        const promise = client.get(
            instrumentCode,
            enableNpr
        );
        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((err) => {});
    }

    public static getInsuredFundTradingAccount(instrumentCode: string, bulkTradeMode: BulkTradeMode, callback: (data) => void): void {
        const client = new InsuredFundTradingAccountClient();
        const promise = client.get(
            instrumentCode,
            bulkTradeMode
        );
        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((err) => {});
    }

    public static postInsuredFundBulkTrading(command: InsuredFundBulkTradeCommand, callback) {
        const client = new InsuredFundBulkTradingClient();
        const promise = client.post(command);
        promise.onSuccess((result) => {
            callback(result);
        });
        promise.onError((error) => {});
    }
}
